<template>
  <div>
    <!-- Filter Start -->
    <div class="innerBox filter">
      <div class="row">
        <div
          class="col-lg-4 col-md-6 align-middle"
          style="
            justify-content: space-between;
            transition: max-width 0.5s ease;
          "
        >
          <h2 class="page-title">Register Muat List</h2>
        </div>

        <template v-if="user.type == 'ADMIN_EKSPEDISI'">
          <div class="col-lg-2 col-md-6">
            <Multiselect
              :options="options.regions"
              placeholder="All Region"
              v-model="filter.region"
              class="tms-multiselect"
            />
            <!-- {{ options.regions }} -->
          </div>
          <div class="col-lg-2 col-md-6">
            <div class="input-group">
              <flat-pickr
                :config="rangePickr"
                placeholder="Select Date"
                v-model="selected.date"
              ></flat-pickr>
              <span
                class="input-group-text bg-white"
                style="
                  border-top-left-radius: 0;
                  border-bottom-left-radius: 0;
                  border: 0;
                  box-shadow: 0 0 6px #0000000f;
                  background-color: #ededed !important;
                "
              >
                <i class="fas fa-calendar" style="color: black"></i>
              </span>
            </div>
          </div>
          <div class="col-lg-2 col-md-6">
            <button
              class="btn"
              type="button"
              style="
                background-color: #f36f21;
                color: white;
                width: 100%;
                font-weight: bold;
                margin: 0;
              "
              @click="modal.upload = true"
            >
              Upload File
            </button>
          </div>
          <div class="col-lg-2 col-md-6">
            <router-link
              to="/dashboard/register-muat/create"
              style="color: white; text-decoration: none"
            >
              <button
                class="btn"
                type="button"
                style="
                  background-color: #f36f21;
                  color: white;
                  width: 100%;
                  font-weight: bold;
                  margin: 0;
                "
              >
                Create Muat
              </button>
            </router-link>
          </div>
        </template>
        <template v-else>
          <div class="col-lg-2 col-md-6">
            <Multiselect
              :options="options.regions"
              placeholder="All Region"
              v-model="filter.region"
              class="tms-multiselect"
            />
            <!-- {{ options.regions }} -->
          </div>
          <div class="col-lg-3 col-md-6">
            <Multiselect
              :options="options.ekspedisi.map((x) => x.id)"
              :custom-label="
                (opt) => options.ekspedisi.find((x) => x.id == opt).kode
              "
              placeholder="All Ekspedisi"
              v-model="filter.ekspedisi"
              class="tms-multiselect"
            />
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="input-group">
              <flat-pickr
                :config="rangePickr"
                placeholder="Select Date"
                v-model="selected.date"
              ></flat-pickr>
              <div class="input-group-append">
                <span
                  class="input-group-text bg-white border-left-0"
                  style="
                    border-top-right-radius: 5px;
                    border-bottom-right-radius: 5px;
                    border: 0;
                    box-shadow: 0 0 6px #0000000f;
                    background-color: #ededed !important;
                  "
                >
                  <i class="fas fa-calendar" style="color: black"></i>
                </span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- Filter End -->

    <!-- Chart Start -->
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="innerBox mt-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text bg-white">
                <i class="fas fa-search"></i>
              </span>
            </div>
            <input
              class="form-control filterInput col-lg-2"
              type="search"
              placeholder="Search by Nopol"
              aria-label="Search"
              v-model="filter.nopol"
              @input="vue_universal_table.update++"
              style="border-left: 0"
            />
          </div>

          <vue-universal-table
            api_url="/api/register-muat/list"
            :indexing="true"
            :fields="vue_universal_table.fields"
            :update="vue_universal_table.update"
            :buttons="vue_universal_table.buttons"
            :filter="filter"
            :table_striped="false"
            :disable_limit_per_page="true"
            @onEdit="editMuat"
            @onDelete="deleteMuat"
          ></vue-universal-table>
        </div>
      </div>
    </div>
    <!-- Chart End -->
    <RegisterMuatUpload
      v-if="modal.upload"
      @closeModal="modal.upload = false"
      @onFinish="fetchData()"
    />
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import qs from "qs";
import debounce from "debounce";
import moment from "moment";
import Multiselect from "vue-multiselect";
import RegisterMuatUpload from './RegisterMuatUpload';

export default {
  metaInfo: {
    title: "Register Muat List",
  },
  data() {
    let startDate = moment().startOf("month").format("YYYY-MM-DD");
    let currentDate = moment().format("YYYY-MM-DD");
    let user = this.$store.getters.currentUser;

    let buttons = null;
    let fields = null;

    if (user.type == "ADMIN_EKSPEDISI") {
      buttons = [
        {
          title: "Edit",
          variable: null,
          class: "fas fa-edit  btn-secondary rounded-button float-right",
        },
        {
          title: "Delete",
          variable: "id",
          class: "fas fa-trash  btn-secondary rounded-button",
        },
      ];
      fields = [
        { title: "Nopol", variable: "nopol", disable_sort: true },
        { title: "Plant Tujuan", variable: "plant_to", disable_sort: true },
        { title: "Kapasitas Truck", variable: "capacity", disable_sort: true },
        {
          title: "Tanggal Buat",
          variable: "register_muat",
          disable_sort: true,
        },
      ];
    } else {
      fields = [
        { title: "Nopol", variable: "nopol", disable_sort: true },
        { title: "Ekspedisi", variable: "kode_ekspedisi", disable_sort: true },
        {
          title: "Tanggal Register",
          variable: "register_muat",
          disable_sort: true,
        },
        { title: "Region", variable: "region", disable_sort: true },
        { title: "Plant Tujuan", variable: "plant_to", disable_sort: true },
        {
          title: "Jumlah Alokasi",
          variable: "jumlah_alokasi",
          disable_sort: true,
        },
        { title: "Kapasitas Truck", variable: "capacity", disable_sort: true },
      ];
    }

    return {
      data: [],
      user,
      apiData: [],
      filter: {
        nopol: "",
        start: startDate,
        end: currentDate,
        ekspedisi: null,
        region: null,
      },
      modal: {
        upload: false,
      },
      options: {
        regions: this.$store.getters.getRegion,
        ekspedisi: this.$store.getters.getEkspedisi,
      },
      vue_universal_table: {
        fields,
        buttons,
        update: 0,
      },
      rangePickr: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d M Y",
        altInputClass: "form-control input grey-flatpickr",
      },
      selected: {
        date: `${startDate} to ${currentDate}`,
      },
      statusOptions: [
        { value: 0, label: "PENDING" },
        { value: 1, label: "APPROVED" },
        { value: 2, label: "REJECTED" },
        { value: 3, label: "APPROVE UPDATE GUDANG" },
        { value: 4, label: "APPROVE UPDATE TANGGAL" },
        { value: 5, label: "APPROVE UPDATE SEMUA" },
      ],
    };
  },
  components: { Multiselect, RegisterMuatUpload },
  computed: {
    selectedStatusValues() {
      return this.filter.selectedStatus.map((label) => {
        const option = this.statusOptions.find(
          (option) => option.label === label
        );
        return option ? option.value : null;
      });
    },
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.update();
      }, // Fetch data when any filter changes
    },
    "selected.date"() {
      let split = this.selected.date.split(" to ");
      this.filter.start = split[0];
      this.filter.end = split.length > 1 ? split[1] : split[0];
    },
    "selected.dateButtonsIndex"() {
      // this.filter.filter = this.selected.dateButtonsIndex != -1 ? this.options.dateButtons[this.selected.dateButtonsIndex].filter : 'CUSTOM'
    },
  },
  methods: {
    update: debounce(function () {
      if (this.filter.region === 'All' || this.filter.ekspedisi === 999) {
        this.filter = {...this.filter, region: null, ekspedisi: null};
      }
      this.vue_universal_table.update++;
    }, 1000),
    fetchData() {
      // Remove filter from filter
      let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
      console.log(
        "%cHighlightLabelMaker.vue line:274 filterlessFilter",
        "color: #007acc;",
        filterlessFilter
      );
      delete filterlessFilter.filter;

      // Fetch data from the API
      axios
        .get(
          `/api/register-muat/list?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((response) => {
          this.data = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    onClick(truck) {
      this.$store.state.truckData = truck;
      this.$router.push({ path: "/dashboard/truck-list/detail" });
    },
    deleteMuat(idToDelete) {
      // Use SweetAlert2 to display a confirmation dialog
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          // If the user confirms the delete, proceed with the DELETE request

          // Define the URL of the DELETE request
          const url = "/api/register-muat/delete/";

          // Define the request body
          const requestBody = {
            id: idToDelete,
          };

          // Make the DELETE request
          axios
            .delete(url, { data: requestBody }) // Pass the request body in the "data" option
            .then(() => {
              // Handle the response, e.g., show a success message
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "The record has been deleted.",
              });
              // Swal.fire("Deleted!", "The record has been deleted.", "success");
              this.$router.go(0);
              // this.vue_universal_table.update++;
            })
            .catch((err) => {
              // Handle errors, e.g., show an error message
              if (err.response.data) {
                Swal.fire(
                  "Error!",
                  "An error occurred while deleting the record.",
                  "error"
                );
              }
            });
        }
      });
    },
    editMuat(editData) {
      // console.log('ini editData', editData);
      // Navigate to the EditMuatPage.vue with the id of the record to edit
      this.$router.push({
        name: "UMuat", //use name for router push
        params: { data: JSON.parse(editData) },
      });
      // this.$router.push({ name: "UMuat", params: { id: idToEdit } });
    },
  },
};
</script>

<style scoped>
.align-middle {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 27px;
  font-weight: bold;
  margin: 0;
}

.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.news-image-1 img {
  max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
  text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
  text-align: left; /* To position the news-content on the bottom right */
}

/* tms-table start */
.tms-table {
  width: 100%;
  border-collapse: collapse;
}

.tms-table th,
.tms-table td {
  padding: 8px;
  text-align: left;
  vertical-align: middle;
}

/* Styling for table headers */
.tms-table th {
  color: #bcbcbc;
  font-weight: normal;
  border-bottom: 0px solid #e4e7ea;
}

/* Styling for table data cells */
.tms-table td {
  font-weight: normal;
}

/* Remove top border from first row */
.tms-table tr:first-child td {
  border-top: none;
}
/* tms-table end */
</style>
